import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 48, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ number, label }) => (
  <div className="flex items-center gap-4 mb-8">
    <span className="font-mono-pv text-xs text-[#00D4FF]">{number}</span>
    <span className="h-px w-12 bg-[#007AFF]/50" />
    <span className="font-mono-pv text-xs uppercase tracking-[0.25em] text-white/50">{label}</span>
  </div>
);
